const config = JSON.parse(
  document.getElementById('js-bundle-runtime-config').innerHTML,
);

export default config;
